<template>
	<section class="dk_kd_jd">
		<el-page-header @back="goBack" content="SKU方案设置"></el-page-header>
		<div class="topic-outer">
			<div class="appraisal-center fonts">
				<div class="pub-line">
					<span>分类：</span>
					<span class="glay"
						>{{ dataObj.categoryName1 }}-{{ dataObj.categoryName }}</span
					>
				</div>
				<div class="flex-box pub-line">
					<div class="fl1">
						<span>名称：</span>
						<span class="glay">{{ dataObj.name }}</span>
					</div>
					<div class="fl1">
						<span> 标识：</span>
						<span class="glay">{{ dataObj.examId }}</span>
					</div>
				</div>
				<div class="flex-box pub-line">
					<div class="fl1">
						<span>解析：</span>
						<span class="glay">{{ dataObj.schemeName }}</span>
					</div>
					<div class="fl1">
						<span> 题目：</span>
						<span class="glay"
							>共 <i>{{ dataObj.questions }}</i
							>题，<i>{{ dataObj.maxScore }}</i
							>分</span
						>
					</div>
				</div>
			</div>
		</div>
		<el-tabs v-model="activeGrouping" type="card" @tab-click="handleGroupClick">
			<el-tab-pane
				:key="index"
				v-for="(item, index) in groupedList"
				:label="item.name"
				:name="item.id + ''"
			></el-tab-pane>
		</el-tabs>
		<div class="role">
			<div class="roleRight">
				<div class="roleRight_Top">
					<el-input
						v-if="searchShow"
						clearable
						size="mini"
						v-model="search.searchKey"
						clas="input_search"
						placeholder="搜索关键字"
						@keyup.enter.native="SearchDictionaryList"
					></el-input>
					<el-select
						size="mini"
						v-if="searchShow"
						v-model="search.status"
						clearable
						placeholder="请选择"
					>
						<el-option
							v-for="item in COMMON_STATUS"
							:key="item.key"
							:label="item.name"
							:value="item.key"
						></el-option>
					</el-select>
					<el-button
						v-if="searchShow"
						size="mini"
						type="primary"
						@click="SearchDictionaryList"
						>查询
					</el-button>
					<el-button
						v-if="addShow"
						size="mini"
						type="primary"
						@click="handleClick('addNext')"
						>新增
					</el-button>
				</div>
				<div class="roleRight_Container public-table-data">
					<el-table
						v-loading="loading"
						:data="tableData"
						size="medium"
						border
						style="width: 100%"
					>
						<el-table-column fixed label="序号" type="index" width="100">
							<template slot-scope="scope">
								<span>{{ scope.$index + 1 }}</span>
							</template>
						</el-table-column>
						<el-table-column prop="name" label="方案名称" min-width="150">
						</el-table-column>
						<el-table-column prop="title" label="标题" min-width="150">
						</el-table-column>
						<el-table-column prop="countryCode" label="标识" min-width="100">
						</el-table-column>
						<el-table-column prop="logo" label="logo" width="100">
							<template slot-scope="scope">
								<el-image
									:src="scope.row.logo"
									style="max-width: 50px; max-height: 50px"
								></el-image>
							</template>
						</el-table-column>
						<el-table-column prop="status" label="状态" width="100">
							<template slot-scope="scope">
								<el-switch
									size="mini"
									:disabled="statusShow"
									v-model="scope.row.status"
									:active-value="1"
									:inactive-value="0"
									@change="changeSwitch(scope.row)"
								>
								</el-switch>
							</template>
						</el-table-column>
						<el-table-column prop="status" label="默认" width="100">
							<template slot-scope="scope">
								<el-switch
									size="mini"
									:disabled="statusShow"
									v-model="scope.row.isDefault"
									:active-value="1"
									:inactive-value="0"
									@change="changeDefaultSwitch(scope.row)"
								>
								</el-switch>
							</template>
						</el-table-column>
						<el-table-column prop="status" label="推荐" width="100">
							<template slot-scope="scope">
								<el-switch
									size="mini"
									:disabled="statusShow"
									v-model="scope.row.isHot"
									:active-value="1"
									:inactive-value="0"
									@change="changeHotSwitch(scope.row)"
								>
								</el-switch>
							</template>
						</el-table-column>
						<el-table-column align="center" prop="sort" label="排序" width="80">
							<template slot-scope="scope">
								<el-input
									size="mini"
									type="text"
									placeholder="输入排序数据"
									v-model="scope.row.sort"
									@blur="changOrdered(scope.row)"
								></el-input>
							</template>
						</el-table-column>
						<el-table-column prop="payPrice" label="价格" width="100">
							<template slot-scope="scope">
								{{ `$ ${formatMinNum(scope.row.payPrice)}` }}
							</template>
						</el-table-column>
						<el-table-column prop="originalPrice" label="划线价" width="100">
							<template slot-scope="scope">
								{{ `$ ${formatMinNum(scope.row.originalPrice)}` }}
							</template>
						</el-table-column>
						<el-table-column fixed="right" label="操作" width="240">
							<template slot-scope="scope">
								<el-button
									@click="handleClick('equity', scope.row)"
									plain
									type="warning"
									size="mini"
									>权益设置
								</el-button>
								<el-button
									@click="handleClick('resource', scope.row)"
									plain
									type="warning"
									size="mini"
									>资源设置
								</el-button>
								<el-button
									@click="handleClick('change', scope.row)"
									plain
									type="primary"
									v-if="editShow"
									size="mini"
									>修改
								</el-button>
								<el-button
									v-if="deleteShow"
									type="danger"
									plain
									size="mini"
									@click="del(scope.row)"
									>删除
								</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
		</div>
		<!-- 编辑弹框 -->
		<el-dialog
			title="编辑/新增SKU方案"
			:visible.sync="dialogVisible"
			:close-on-click-modal="false"
			width="700px"
			class="public-dialog"
		>
			<div class="public-dialog-form">
				<el-form
					ref="ruleForm"
					:rules="rules"
					:model="params"
					label-width="100px"
				>
					<el-tabs
						type="card"
						v-model="languageCode"
						@tab-click="handleTabClick"
					>
						<el-tab-pane
							v-for="(item, index) in languageList"
							:label="item.name"
							:name="item.code"
							:key="index"
						></el-tab-pane>
					</el-tabs>
					<el-row>
						<el-col :span="16">
							<el-form-item label="方案名称：" prop="name">
								<el-input
									clearable
									placeholder="请填写方案标题"
									v-model="params.name"
								></el-input>
							</el-form-item>
							<el-form-item label="标题：" prop="title">
								<el-input
									clearable
									placeholder="请填写方案标题"
									v-model="params.title"
								></el-input>
							</el-form-item>
							<el-form-item label="副标题：" prop="subtitle">
								<el-input
									clearable
									placeholder="请填写方案副标题"
									v-model="params.subtitle"
								></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="logo：">
								<upLoadImg
									:keyWord="'logo'"
									:params="params"
									v-if="flag"
								></upLoadImg>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="8">
							<el-form-item label="价格($)：" prop="payPrice">
								<el-input
									type="number"
									clearable
									placeholder="请填写方案价格"
									v-model="params.payPrice"
								></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="划线价($)：" prop="originalPrice">
								<el-input
									type="number"
									clearable
									placeholder="请填写划线价"
									v-model="params.originalPrice"
								></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="销量：" prop="sort">
								<el-input
									type="number"
									clearable
									placeholder="请填写方案销量"
									v-model="params.sales"
								></el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="选择方式：">
								<el-select
									style="width: 100%"
									v-model="params.chooseType"
									clearable
									placeholder="请选择"
								>
									<el-option label="内容多选" :value="1"></el-option>
									<el-option label="复合方案" :value="0"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="默认：">
								<el-switch
									v-model="params.isDefault"
									active-color="#13ce66"
									:active-value="1"
									:inactive-value="0"
									inactive-color="#ff4949"
								>
								</el-switch>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="热门推荐：">
								<el-switch
									v-model="params.isHot"
									active-color="#13ce66"
									:active-value="1"
									:inactive-value="0"
									inactive-color="#ff4949"
								>
								</el-switch>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="8">
							<el-form-item label="国家：">
								<el-select
									style="width: 100%"
									v-model="params.countryCode"
									clearable
									placeholder="请选择国家"
								>
									<el-option
										v-for="(item, index) in countryList"
										:value="item.code"
										:key="index"
										:label="item.name"
									></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="方案类型：">
								<el-select
									style="width: 100%"
									v-model="params.type"
									clearable
									placeholder="请选择方案类型"
								>
									<el-option :value="1" label="答题支付方案"></el-option>
									<el-option :value="2" label="报告方案"></el-option>
									<el-option :value="3" label="折扣方案"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="排序：" prop="sort">
								<el-input
									type="number"
									clearable
									placeholder="请填写权益排序"
									v-model="params.sort"
								></el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-form-item label="描述：" prop="content">
						<el-input
							clearable
							type="textarea"
							:autosize="{ minRows: 4, maxRows: 4 }"
							placeholder="请填写描述"
							v-model="params.remark"
						></el-input>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="public-dialog-footer">
				<el-button size="medium" @click="dialogVisible = false"
					>取 消</el-button
				>
				<el-button size="medium" type="primary" @click="handleEdit"
					>提 交</el-button
				>
			</span>
		</el-dialog>
		<!-- 绑定权益列表 -->
		<el-dialog
			title="绑定方案权益"
			:visible.sync="innerVisible"
			:close-on-click-modal="false"
			width="800px"
			style="cursor: pointer"
			class="public-dialog"
		>
			<div class="public-dialog-form">
				<div style="display: flex; align-items: center; margin-bottom: 20px">
					<div class="item-son" style="margin-right: 20px">
						<el-input
							size="mini"
							style="width: 200px"
							v-model="searchContent.searchValue"
							placeholder="搜索关键词"
							clearable
							@keyup.enter.native="getAllBenefitList"
						></el-input>
					</div>
					<div class="item-son" style="margin-right: 20px">
						<el-select
							size="mini"
							v-model="searchContent.parentId"
							clearable
							placeholder="请选择"
						>
							<el-option
								v-for="(item, index) in benefitGroupList"
								:label="item.name"
								:value="item.id"
								:key="index"
							></el-option>
						</el-select>
					</div>
					<div class="item-son">
						<el-button size="mini" type="primary" @click="getAllBenefitList"
							>查询 <i class="el-icon-search"></i>
						</el-button>
					</div>
				</div>
				<el-tabs v-model="isFree" type="card" @tab-click="handleBenefitClick">
					<el-tab-pane label="免费权益" name="1"></el-tab-pane>
					<el-tab-pane label="付费权益" name="0"></el-tab-pane>
				</el-tabs>
				<div class="public-table-data" style="padding-bottom: 20px">
					<el-table
						ref="multipleTable"
						size="medium"
						:data="allBenefitList"
						border
						height="50vh"
						v-loading="loading"
						@selection-change="handleSelectionChange"
					>
						<el-table-column type="selection" width="55"></el-table-column>
						<el-table-column
							type="index"
							label="序号"
							width="80"
							align="center"
						>
						</el-table-column>
						<el-table-column prop="name" label="标题" align="center">
						</el-table-column>
						<el-table-column prop="logo" label="logo" width="100">
							<template slot-scope="scope">
								<el-image
									:src="scope.row.logo"
									style="max-width: 50px; max-height: 50px"
								></el-image>
							</template>
						</el-table-column>
						<el-table-column
							prop="descr"
							label="价格"
							width="100"
							align="center"
						>
							<template slot-scope="scope">
								<span>{{ `$ ${formatMinNum(scope.row.payPrice)}` }}</span>
							</template>
						</el-table-column>
						<el-table-column prop="content" label="内容" align="center">
						</el-table-column>
					</el-table>
				</div>
				<span slot="footer" class="public-dialog-footer">
					<el-button size="medium" @click="innerVisible = false"
						>取 消</el-button
					>
					<el-button size="medium" type="primary" @click="handleTopicList"
						>确 定</el-button
					>
				</span>
			</div>
		</el-dialog>
		<!-- 已绑定权益列表 -->
		<el-dialog
			title="已绑定权益"
			:visible.sync="bindInnerVisible"
			:close-on-click-modal="false"
			width="1000px"
			style="cursor: pointer"
			class="public-dialog"
		>
			<div class="public-dialog-form">
				<div class="public-table-data udb_jjd_kdn" style="padding-bottom: 20px">
					<div class="content_kksu_jdn">
						<div class="main-nav"><span>免费权益</span></div>
						<el-table
							size="medium"
							:data="bindfreeBenefitList"
							border
							v-loading="loading"
						>
							<el-table-column
								type="index"
								label="序号"
								width="80"
								align="center"
							>
							</el-table-column>
							<el-table-column prop="name" label="标题" align="center">
							</el-table-column>
							<el-table-column prop="logo" label="logo" width="100">
								<template slot-scope="scope">
									<el-image
										:src="scope.row.logo"
										style="max-width: 50px; max-height: 50px"
									></el-image>
								</template>
							</el-table-column>
							<el-table-column
								prop="remarks"
								label="类型"
								width="150"
								align="center"
							>
								<template slot-scope="scope">
									<div v-if="scope.row.categoryType == 1">测评结果内容</div>
									<div v-if="scope.row.categoryType == 2">测评送题</div>
									<div v-if="scope.row.categoryType == 3">进阶课程</div>
									<div v-if="scope.row.categoryType == 4">会员</div>
									<div v-if="scope.row.categoryType == 5">优惠券</div>
									<div v-if="scope.row.categoryType == 6">错题集</div>
								</template>
							</el-table-column>
							<el-table-column
								prop="descr"
								label="价格"
								width="100"
								align="center"
							>
								<template slot-scope="scope">
									<span>{{ `$ ${formatMinNum(scope.row.payPrice)}` }}</span>
								</template>
							</el-table-column>
							<el-table-column prop="content" label="内容" align="center">
							</el-table-column>
							<el-table-column label="操作" width="100" align="center">
								<template slot-scope="scope">
									<el-button
										type="danger"
										plain
										size="mini"
										@click="bindBenefitDel(scope.row)"
										>删除
									</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div class="content_kksu_jdn">
						<div class="main-nav"><span>付费权益</span></div>
						<el-table
							size="medium"
							:data="bindNoFreeBenefitList"
							border
							v-loading="loading"
						>
							<el-table-column
								type="index"
								label="序号"
								width="80"
								align="center"
							>
							</el-table-column>
							<el-table-column prop="name" label="标题" align="center">
							</el-table-column>
							<el-table-column prop="logo" label="logo" width="100">
								<template slot-scope="scope">
									<el-image
										:src="scope.row.logo"
										style="max-width: 50px; max-height: 50px"
									></el-image>
								</template>
							</el-table-column>
							<el-table-column
								prop="remarks"
								label="类型"
								width="150"
								align="center"
							>
								<template slot-scope="scope">
									<div v-if="scope.row.categoryType == 1">测评结果内容</div>
									<div v-if="scope.row.categoryType == 2">测评送题</div>
									<div v-if="scope.row.categoryType == 3">进阶课程</div>
									<div v-if="scope.row.categoryType == 4">会员</div>
									<div v-if="scope.row.categoryType == 5">优惠券</div>
									<div v-if="scope.row.categoryType == 6">错题集</div>
								</template>
							</el-table-column>
							<el-table-column
								prop="descr"
								label="价格"
								width="100"
								align="center"
							>
								<template slot-scope="scope">
									<span>{{ `$ ${formatMinNum(scope.row.payPrice)}` }}</span>
								</template>
							</el-table-column>
							<el-table-column prop="content" label="内容" align="center">
							</el-table-column>
							<el-table-column label="操作" width="100" align="center">
								<template slot-scope="scope">
									<el-button
										type="danger"
										plain
										size="mini"
										@click="bindBenefitDel(scope.row)"
										>删除
									</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
				<span slot="footer" class="public-dialog-footer">
					<el-button size="medium" @click="bindInnerVisible = false"
						>取 消</el-button
					>
					<el-button size="medium" type="primary" @click="changBindBenefitList"
						>绑定权益</el-button
					>
				</span>
			</div>
		</el-dialog>
		<!-- 已绑定资源列表 -->
		<el-dialog
			title="已绑定资源"
			:visible.sync="bindResourceVisible"
			:close-on-click-modal="false"
			width="1000px"
			style="cursor: pointer"
			class="public-dialog"
		>
			<div class="public-dialog-form">
				<div class="public-table-data udb_jjd_kdn" style="padding-bottom: 20px">
					<div class="content_kksu_jdn">
						<div class="main-nav"><span>已绑定资源</span></div>
						<el-table
							size="medium"
							:data="bindResourcetList"
							border
							v-loading="loading"
						>
							<el-table-column
								type="index"
								label="序号"
								width="80"
								align="center"
							>
							</el-table-column>
							<el-table-column prop="name" label="标题" align="center">
							</el-table-column>
							<el-table-column prop="content" label="内容" align="center">
								<template slot-scope="scope">
									<div
										style="white-space: pre-line; height: 50px; overflow: auto"
										v-html="scope.row.content"
									></div>
								</template>
							</el-table-column>
							<el-table-column label="操作" width="100" align="center">
								<template slot-scope="scope">
									<el-button
										type="danger"
										plain
										size="mini"
										@click="bindResourceDel(scope.row)"
										>删除
									</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
				<span slot="footer" class="public-dialog-footer">
					<el-button size="medium" @click="bindResourceVisible = false"
						>取 消</el-button
					>
					<el-button size="medium" type="primary" @click="changBindResourceList"
						>绑定资源</el-button
					>
				</span>
			</div>
		</el-dialog>
		<!-- 绑定资源列表 -->
		<el-dialog
			title="绑定资源列表"
			:visible.sync="resourceVisible"
			:close-on-click-modal="false"
			width="800px"
			style="cursor: pointer"
			class="public-dialog"
		>
			<div class="public-dialog-form">
				<div class="public-table-data" style="padding-bottom: 20px">
					<el-table
						ref="multipleResourceTable"
						size="medium"
						:data="allResourceList"
						border
						height="50vh"
						v-loading="loading"
						@selection-change="handleSelectionResourceChange"
					>
						<el-table-column type="selection" width="55"></el-table-column>
						<el-table-column
							type="index"
							label="序号"
							width="80"
							align="center"
						>
						</el-table-column>
						<el-table-column prop="name" label="标题" align="center">
						</el-table-column>
						<el-table-column prop="content" label="内容" align="center">
							<template slot-scope="scope">
								<div
									style="white-space: pre-line; height: 50px; overflow: auto"
									v-html="scope.row.content"
								></div>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<span slot="footer" class="public-dialog-footer">
					<el-button size="medium" @click="resourceVisible = false"
						>取 消</el-button
					>
					<el-button
						size="medium"
						type="primary"
						@click="handleResourceTopicList"
						>确 定</el-button
					>
				</span>
			</div>
		</el-dialog>
	</section>
</template>
<script>
import { COMMON_STATUS } from "@/config";
import { formatMinNum } from "@utils/tools/index";
import upLoadImg from "@views/app/components/upLoadImg";

export default {
	components: { upLoadImg },
	data() {
		return {
			formatMinNum,
			COMMON_STATUS,
			loading: false,
			search: {},
			dialogVisible: false, //弹出框显示隐藏
			clickType: "", //弹窗类型
			params: {}, //弹窗修改数据
			rules: {
				name: [
					{ required: true, message: "请填写权益标题", trigger: "change" },
				],
				payPrice: [
					{ required: true, message: "请填写权益价格", trigger: "change" },
				],
				originalPrice: [
					{ required: true, message: "请填写划线价", trigger: "change" },
				],
			}, //表单验证提示
			tableData: [], //二级--列表
			addShow: true,
			deleteShow: true,
			editShow: true,
			statusShow: false,
			searchShow: true,
			dataObj: {},
			groupedList: [],
			activeGrouping: "",
			flag: false,
			searchContent: {
				searchValue: "",
				parentId: "",
				examCode: this.$route.query.examId,
			},
			allBenefitList: [],
			allResourceList: [],
			innerVisible: false,
			resourceVisible: false,
			benefitGroupList: [],
			isFree: "1",
			skuPackageData: {},
			bindInfoContent: [],
			bindInfoResourceContent: [],
			bindInnerVisible: false,
			bindResourceVisible: false,
			bindfreeBenefitList: [],
			bindResourcetList: [],
			bindNoFreeBenefitList: [],
			languageList: [],
			languageCode: "",
			countryList: [],
		};
	},
	created() {
		this.getVipRightList();
		this.getAppraisalData();
		this.getAllBenefitList();
		this.getBenefitGroupList();
		this.getLanguageList();
		this.getCountryList();
	},
	watch: {
		dialogVisible() {
			if (this.dialogVisible == false) {
				this.$refs["ruleForm"].resetFields();
				this.params = {};
				this.flag = false;
			}
		},
	},
	methods: {
		async getCountryList() {
			this.loading = true;
			//角色列表
			const { data: res } = await this.$post(`/country/page`, {
				status: 1,
				pageNo: 1,
				pageSize: 9999,
			});
			this.loading = false;
			this.countryList = res.data;
		},

		handleTabClick() {
			if (this.params.id) {
				this.getEquityInfo();
			}
		},
		async getEquityInfo() {
			this.flag = false;
			this.loading = true;
			const { data: resData } = await this.$get(
				"/sku/package/info/" + this.params.id,
				{
					headers: {
						isLoading: true,
						"Language-Code": this.languageCode,
					},
				}
			);
			this.loading = false;
			this.params = JSON.parse(JSON.stringify(resData.data));
			this.params.payPrice = this.params.payPrice / 100;
			this.params.originalPrice = this.params.originalPrice / 100;
			this.$nextTick(() => {
				this.flag = true;
			});
		},
		//获取语言列表
		async getLanguageList() {
			this.loading = true;
			//角色列表
			const { data: res } = await this.$post(`/language/list`, {
				adminStatus: 1,
			});
			this.loading = false;
			this.languageList = res.data;
			this.languageCode = res.data[0].code;
		},
		/**
		 * 删除方案
		 */
		bindBenefitDel(row) {
			this.$confirm("一旦删除无法恢复, 是否继续?", "提示", {
				type: "warning",
			}).then(async () => {
				const { data: resData } = await this.$get(
					`/sku/package/ref/delete/${row.refId}`,
					{
						headers: {
							isLoading: true,
						},
					}
				);
				if (resData.result != 200) return;
				this.getBindBenefitList(this.skuPackageData);
				this.$message.success("删除成功!");
			});
		},
		bindResourceDel(row) {
			this.$confirm("一旦删除无法恢复, 是否继续?", "提示", {
				type: "warning",
			}).then(async () => {
				const { data: resData } = await this.$get(
					`/sku/package/resource/delete/${this.skuPackageData.id}/${row.id}`,
					{
						headers: {
							isLoading: true,
						},
					}
				);
				if (resData.result != 200) return;
				this.getBindResourceList(this.skuPackageData);
				this.$message.success("删除成功!");
			});
		},
		handleSelectionChange(e) {
			this.bindInfoContent = this.processingData(e);
		},
		handleSelectionResourceChange(e) {
			this.bindInfoResourceContent = e.map((item) => item.id);
		},
		handleBenefitClick() {
			this.$refs.multipleTable.clearSelection();
		},
		changBindBenefitList() {
			this.innerVisible = true;
		},
		async changBindResourceList() {
			this.allResourceList = [];
			const { data: resData } = await this.$get(
				`/merchant/vip/resource//${this.dataObj.examInfoId}`
			);
			if (resData.result != 200) return;
			if (resData.data) {
				this.allResourceList = resData.data;
				this.resourceVisible = true;
			}
		},
		async handleTopicList() {
			let objData = {
				isFree: this.isFree,
				skuPackageId: this.skuPackageData.id,
				skuRefInfos: this.bindInfoContent,
			};
			const { data: resData } = await this.$post(
				"/sku/package/ref/bind",
				objData
			);
			if (resData.result != 200) return;
			this.$message({
				message: resData.message,
				type: "success",
			});
			this.getBindBenefitList(this.skuPackageData);
			this.$refs.multipleTable.clearSelection();
		},
		async handleResourceTopicList() {
			let objData = {
				packageId: this.skuPackageData.id,
				resourceIds: this.bindInfoResourceContent,
			};
			const { data: resData } = await this.$post(
				"/sku/package/resource/save",
				objData
			);
			if (resData.result != 200) return;
			this.$refs.multipleResourceTable.clearSelection();
			this.getBindResourceList(this.skuPackageData);
			this.resourceVisible = false;
		},
		processingData(data) {
			let arr = [];
			data.map((item) => {
				let obj = {
					categoryType: item.categoryType,
					skuCode: item.skuCode,
				};
				arr.push(obj);
			});
			return arr;
		},
		/**
		 * 获取权益分组
		 */
		async getBenefitGroupList() {
			this.loading = true;
			const { data: resData } = await this.$get(
				`/sku/group/list/${this.$route.query.examId}`
			);
			this.loading = false;
			if (resData.result != 200) return;
			this.benefitGroupList = resData.data;
		},
		/**
		 * 获取已经绑定的权益列表
		 */
		async getBindBenefitList(data) {
			this.loading = true;
			const { data: resData } = await this.$get(
				`/sku/package/ref/list/${data.id}`
			);
			this.loading = false;
			if (resData.result != 200) return;
			this.bindfreeBenefitList = [];
			this.bindNoFreeBenefitList = [];
			resData.data.map((item) => {
				if (item.ifFree == 1) {
					this.bindfreeBenefitList.push(item);
				} else if (item.ifFree == 0) {
					this.bindNoFreeBenefitList.push(item);
				}
			});
		},
		/**
		 * 根据方案ID获取绑定的资源列表
		 */
		async getBindResourceList(data) {
			this.loading = true;
			const { data: resData } = await this.$get(
				`/sku/package/resource/list/${data.id}`
			);
			this.loading = false;
			if (resData.result != 200) return;
			this.bindResourcetList = resData.data;
		},
		/**
		 * 获取已经绑定的权益列表
		 */
		async getAllBenefitList() {
			this.loading = true;
			const { data: resData } = await this.$post(
				`/sku/list/search`,
				this.searchContent
			);
			this.loading = false;
			if (resData.result != 200) return;
			this.allBenefitList = resData.data;
		},
		/**
		 * 获取测评详情
		 */
		async getAppraisalData() {
			this.loading = true;
			const { data: resData } = await this.$get(
				`exam/info/${this.$route.query.examId}`
			);
			this.loading = false;
			if (resData.result != 200) return;
			this.dataObj = resData.data;
		},
		/**
		 *  获取方案分组列表
		 */
		async getVipRightList() {
			let http = "/sku/package/group/list/" + this.$route.query.examId;
			this.loading = true;
			const { data: resData } = await this.$get(http);
			this.loading = false;
			if (resData.data) {
				this.groupedList = resData.data;
				if (this.activeGrouping == 0 || this.activeGrouping == "") {
					this.activeGrouping = resData.data[0].id + "";
				}
				this.getEquityList();
			} else {
				this.groupedList = [];
				this.$confirm(
					"当前测评题还没有设置分组，权益设置需要现在设置分组，是否去设置分组?",
					"提示",
					{
						type: "info",
					}
				).then(async () => {
					this.$router.push({
						name: "SCHEME_GROUPING",
						query: { examId: this.$route.query.examId },
					});
				});
			}
		},
		/**
		 *  获取分组的方案列表
		 */
		async getEquityList() {
			let http = "/sku/package/list/byGroupId/" + this.activeGrouping;
			this.loading = true;
			const { data: resData } = await this.$get(http, { params: this.search });
			this.loading = false;
			if (resData.data) {
				this.tableData = resData.data;
			} else {
				this.tableData = [];
			}
		},
		/**
		 * 修改权益状态
		 */
		async changeSwitch(data) {
			const { data: resData } = await this.$get(
				`/sku/package/updateStatus/${data.id}`
			);
			this.loading = false;
			if (resData.result != 200) return;
			this.$message({
				message: resData.message,
				type: "success",
			});
		},
		/**
		 * 修改默认状态
		 */
		async changeDefaultSwitch(data) {
			const { data: resData } = await this.$get(
				`/sku/package/isDefault/${data.id}`
			);
			this.loading = false;
			if (resData.result != 200) return;
			this.$message({
				message: resData.message,
				type: "success",
			});
			this.getEquityList();
		},
		/**
		 * 修改热门状态
		 */
		async changeHotSwitch(data) {
			const { data: resData } = await this.$get(
				`/sku/package/isHot/${data.id}`
			);
			this.loading = false;
			if (resData.result != 200) return;
			this.$message({
				message: resData.message,
				type: "success",
			});
		},
		/**
		 * 设置方案排序
		 */
		async changOrdered(data) {
			let objData = {
				id: data.id,
				sort: data.sort,
			};
			const { data: resData } = await this.$post(
				"/sku/package/updateSort",
				objData
			);
			if (resData.result != 200) return;
			this.$message({
				message: resData.message,
				type: "success",
			});
			this.getEquityList();
		},
		/**
		 * 方案操作按钮
		 */
		handleClick(type, row = {}) {
			this.clickType = type;
			if (type == "change") {
				this.params = JSON.parse(JSON.stringify(row));
				this.dialogVisible = true;
				this.getEquityInfo();
			} else if (type == "addNext") {
				this.params = {};
				this.dialogVisible = true;
				this.$nextTick(() => {
					this.flag = true;
				});
			} else if (type == "equity") {
				this.bindInnerVisible = true;
				this.skuPackageData = JSON.parse(JSON.stringify(row));
				this.getBindBenefitList(row);
			} else if (type == "resource") {
				this.bindResourceVisible = true;
				this.skuPackageData = JSON.parse(JSON.stringify(row));
				this.getBindResourceList(row);
			}
		},
		/**
		 * 方案提交保存
		 */
		handleEdit() {
			this.$refs.ruleForm.validate((valid) => {
				if (!valid) return;
				this.$confirm("确认提交修改, 是否继续?", "提示", {
					type: "info",
				}).then(async () => {
					this.params.examCode = this.$route.query.examId;
					this.params.parentId = this.activeGrouping;
					this.params.status = 1;
					let b = this.params.payPrice * 100;
					let c = b.toFixed(1);
					let o = this.params.originalPrice * 100;
					let oc = o.toFixed(1);
					this.params.payPrice = parseInt(c);
					this.params.originalPrice = parseInt(oc);
					const { data: resData } = await this.$post(
						"/sku/package/save",
						this.params,
						{
							headers: {
								isLoading: true,
								"Language-Code": this.languageCode,
							},
						}
					);
					this.params = resData.data;
					this.getEquityInfo();
					this.getVipRightList();
				});
			});
		},
		/**
		 * 删除方案
		 */
		del(row) {
			this.$confirm("一旦删除无法恢复, 是否继续?", "提示", {
				type: "warning",
			}).then(async () => {
				const { data: resData } = await this.$get(
					`/sku/package/delete/${row.id}`,
					{
						headers: {
							isLoading: true,
						},
					}
				);
				if (resData.result != 200) return;
				this.getVipRightList();
				this.$message.success("删除成功!");
			});
		},
		/**
		 * 返回
		 */
		goBack() {
			this.$router.go(-1);
		},
		/**
		 * 搜索
		 */
		SearchDictionaryList() {
			this.getEquityList();
		},
		/**
		 * 方案分组切换
		 */
		handleGroupClick() {
			this.getEquityList();
		},
	},
};
</script>
<style lang="scss" scoped>
.role {
	display: flex;
	color: #666; /** 公共的黑色 --暂定 */
	font-size: 14px;

	&Right {
		flex: 1;
		display: flex;
		overflow-x: hidden;
		flex-direction: column;

		&_Top {
			display: flex;
			gap: 15px;
			overflow-x: hidden;

			.el-input {
				width: auto;
			}
		}

		&_Container {
			margin-top: 20px;

			.screenshot {
				position: relative;
			}
		}

		&_pagenation {
			margin: 40px auto;
		}
	}

	::v-deep .el-table th,
	::v-deep .el-table td {
		text-align: center !important;
	}
}

.topic-outer {
	width: 100%;
	background: #fff;
	overflow: hidden;
	margin-top: 20px;
	padding-bottom: 30px;
	border: 0;
}

.flex-box {
	display: -webkit-box;
	display: -moz-box;
	display: -ms-flexbox;
	display: -webkit-flex;
	display: flex;
}

.fl1 {
	flex: 1;
	-webkit-flex: 1;
}

.glay {
	color: #8492a6;

	i {
		font-style: normal;
		color: #f56c6c;
	}
}

.pub-line {
	margin-top: 30px;
}

.pub-marr {
	margin-top: 20px;
}

.marr {
	margin-top: 30px;
}

.tag-marr {
	margin-right: 5px;
	cursor: pointer;
}

.subject {
	color: #8492a6;
	margin-left: 10px;

	i {
		font-style: normal;
		color: #f56c6c;
	}
}

.activeBg {
	background: #b3d8ff;
	color: #fff;
}

.active-bg1 {
	background: #fbc4c4;
	color: #fff;
}

.item_contents {
	display: flex;

	.remove_icon {
		margin-left: 10px;
	}
}

.input_item {
	display: flex;
	align-items: center;
	margin-bottom: 10px;
	font-size: 14px;

	.name {
		margin-right: 5px;
	}
}

.content_kksu_jdn {
	margin-bottom: 20px;
}

.udb_jjd_kdn {
	height: 60vh;
	overflow-y: scroll;
}

.main-nav {
	position: relative;
	margin-bottom: 10px;

	span {
		padding-left: 10px;
		font-size: 16px;
		font-weight: 700;
		text-align: center;
		color: #585858;
	}
}

.main-nav::before {
	content: "";
	width: 3px;
	height: 18px;
	background: -webkit-gradient(
		linear,
		left bottom,
		left top,
		from(#e84d4c),
		to(#f58360)
	);
	background: linear-gradient(0deg, #e84d4c 0%, #f58360 100%);
	border-radius: 2px;
	position: absolute;
	left: 0;
}
</style>

<style>
.dk_kd_jd .el-table__body-wrapper {
	overflow-y: scroll;
	padding-right: 20px;
}
</style>
